import { axios } from "../config";

function addUserRole(data) {
  return axios.post(`api/v1/users/super-admin`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

function updateUserRole(id, data) {
  return axios.post(`api/v1/users/super-admin/${id}`, data, 
    {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
);
}

function deleteUserRole(id) {
  return axios.delete(`api/v1/users/super-admin/${id}`, );
}

function getAllSuperAdmins(data) {
  return axios.get(`api/v1/users/super-admin`, {params: data});
}

function getSuperAdminPrivileges() {
  return axios.get('api/v1/privileges/?type=SUPER-ADMIN');
}
export { addUserRole, getAllSuperAdmins, deleteUserRole, updateUserRole, getSuperAdminPrivileges };
